// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}


.home {
  position: relative;
  justify-content: start;
  display: grid;
  margin-top: 27px;
  margin-left: 5px;

  p {
    font-size: 24px;
    font-weight: bold;
  }
}

.MuiTextField-root {
  margin: -1px !important;
  min-width: 320px;
}

.from-timepicker {
  /* min-width: 152px !important;
  width: 152px !important;
  margin-right: 18px !important;
  height: 35px !important;
  flex-direction: row !important; */
  min-width: 110px !important;
  width: 110px !important;
  margin-right: 30px !important;
  height: 35px !important;
  flex-direction: row !important;
}

.to-timepicker {
  /* width: 152px;
  min-width: 152px !important;
  margin-top: 0px !important;
  height: 35px !important;
  flex-direction: row !important; */
  width: 110px;
  min-width: 110px !important;
  margin-top: 0px !important;
  height: 35px !important;
  flex-direction: row !important;
}

.MuiInputLabel-root {
  margin-top: -9px !important;
}

.MuiStack-root {
  display: inline-table !important;
}

.container-space {
  padding-left: 30px;
  margin-top: 0px;
}

.MuiPaper-root {
  margin-bottom: 0.25rem !important;
  border-radius: 4px !important;
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
}

/* .MuiPaper-root .MuiAccordionSummary-root {
  margin-bottom: 10px !important;
} */

.css-uvvswg-MuiButtonBase-root-MuiAccordionSummary-root {
  background-color: unset !important;
}

.css-1fderfv-MuiPaper-root-MuiAccordion-root:not(:last-child) {
  border-bottom: inset !important;
}

.css-1fderfv-MuiPaper-root-MuiAccordion-root {
  border-radius: 6px;
}

.Mui-expanded .MuiAccordionSummary-root:first-of-type {
  border-radius: 4px !important;
  background: #1fb5ad !important;
  margin-bottom: 10px !important;
}

.Mui-expanded>.MuiTypography-root {
  font-weight: 600 !important;
  font-size: 1rem !important;
  /*1.25rem !important; */
  color: #ffffff;
}


.MuiAccordionSummary-root {
  font-weight: 600 !important;
  font-size: 1rem !important;
  /*1.25rem !important; */
  color: #767676;
  font-family: sans-serif !important;
}

.MuiTypography-root {
  font-weight: 600 !important;
  font-size: 1rem !important;
  /*1.25rem !important; */
  color: #767676;
  font-family: sans-serif !important;
}

.Mui-expanded .MuiAccordionSummary-expandIconWrapper {
  color: #ffffff !important;
}

.MuiAccordionDetails-root {
  padding: 1px 16px 16px !important;
}



.Card-Icon {
  background: #f3ebfd;
  padding: 5px;
  border-radius: 4px;
  width: 45px !important;
  height: 45px !important;
}

.Card {
  padding: 10px;
  height: 60px;
  margin-right: 5px;
}

.Card-Text {
  color: #767676 !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  text-align: center;
  display: block;
  top: 30px !important;
  position: absolute;
}

.Card-text-Percentage {
  color: #e857b8 !important;
  font-size: 9px !important;
  background: #f3ebfd;
  width: 80px;
  text-align: center;
  border-radius: 2px;
  letter-spacing: 0.5px;
  font-weight: bold !important;
  margin-top: 10px !important;
}

.LeftText1 {
  /* position: absolute;
  right: 26px;
  top: 77px; */
  border-left: 1.4px solid #f3f2f2;
  padding: 2px 4px 8px 32px;
  min-width: 3rem;
}

.__LeftText2 {
  margin: 0;
  padding: 0;
  font-size: 22px !important;
  font-weight: 700 !important;
  color: #748076 !important;
}

.__LeftText3 {
  margin: 0;
  font-size: 9px !important;
  text-align: center !important;
  color: #748076 !important;
}

._InputBox {
  width: -webkit-fill-available !important;
  height: 40px !important;
  margin-top: 1px;
}

.__Input-label {
  font-size: 12px !important;
  font-weight: 600 !important;
  padding: 3px 0 0px 3px !important;
  margin-bottom: 4px;
}

.__buttonleft {
  margin-right: 36px !important;
  display: flex;
  justify-content: flex-end;
}

.__butn {
  background: #1fb5ad !important;
  font-size: 12px !important;
  text-transform: capitalize !important;
  width: 100px !important;
}

.MuiInputBase-input {
  font-size: 13px !important;
}

.css-v84d5j-MuiSvgIcon-root {
  font-size: 1.3rem !important;
  text-align: justify;
}

.MuiFormControl-root {
  max-width: 100% !important;
}


.MuiFormControl-root:first-child>.MuiFormLabel-root {
  display: none !important;
}

.MuiFormControl-root .css-14lo706 {
  display: none !important;
}

.MuiFormControl-root:nth-child(2)>.MuiFormLabel-root {
  left: -2.4rem !important;
  top: 1.4rem !important;
  font-size: 19px;
}

.css-9npbnl-MuiFormLabel-root-MuiInputLabel-root {
  margin-bottom: 0 !important;
}

.css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root {
  margin-top: 0 !important;
  /* padding: 0px 9px 8px 0 !important; */
}

.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root {
  padding: 0px 9px 8px 0 !important;
}

.switchform {
  flex-direction: row !important
}

.infoicon {
  margin: 10px 0 0 0;
  color: rgb(34 0 70);
  border: 2px solid #bdb9b9;
  border-radius: 50%;
  background: #ffffff;
}

.MuiGrid-item {
  position: relative !important;
}

.MuiGrid-item:nth-child(1) .MuiFormControl-root {
  margin-top: 2px !important;
  width: -webkit-fill-available !important;
}


.MuiGrid-item:nth-child(2) .MuiFormControl-root {
  margin-top: -2px !important;
  width: -webkit-fill-available !important;
}

.Toastify__toast--error {
  color: #000000 !important;
  background-color: #ff7f7f !important;
  /* Set your desired background color */
}

.Toastify__toast--success {
  color: #000000 !important;
  background-color: #7fff7f !important;
  /* Set your desired background color */
}

.Toastify__toast--info {
  color: #000000 !important;
  background-color: #fdff7f !important;
  /* Set your desired background color */
}

@media only screen and (max-width: 500px) {
  .to-timepicker {
    margin-top: 10px !important;
  }
}

@media only screen and (max-width: 700px) {
  .to-timepicker {
    margin-top: 10px !important;
  }
}

@media only screen and (max-width: 800px) {
  .to-timepicker {
    margin-top: 10px !important;
  }
}

.griddd .MuiGrid-root .MuiGrid-item {
  padding-left: 16px !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;;AAGA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;;EAEhB;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;;;;mCAIiC;EACjC,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;EAC7B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE;;;;mCAIiC;EACjC,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,gDAAgD;AAClD;;AAEA;;GAEG;;AAEH;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;EACvB,cAAc;AAChB;;;AAGA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;EACvB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;EACvB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;;;AAIA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE;;cAEY;EACZ,gCAAgC;EAChC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;;AAGA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n\n.home {\n  position: relative;\n  justify-content: start;\n  display: grid;\n  margin-top: 27px;\n  margin-left: 5px;\n\n  p {\n    font-size: 24px;\n    font-weight: bold;\n  }\n}\n\n.MuiTextField-root {\n  margin: -1px !important;\n  min-width: 320px;\n}\n\n.from-timepicker {\n  /* min-width: 152px !important;\n  width: 152px !important;\n  margin-right: 18px !important;\n  height: 35px !important;\n  flex-direction: row !important; */\n  min-width: 110px !important;\n  width: 110px !important;\n  margin-right: 30px !important;\n  height: 35px !important;\n  flex-direction: row !important;\n}\n\n.to-timepicker {\n  /* width: 152px;\n  min-width: 152px !important;\n  margin-top: 0px !important;\n  height: 35px !important;\n  flex-direction: row !important; */\n  width: 110px;\n  min-width: 110px !important;\n  margin-top: 0px !important;\n  height: 35px !important;\n  flex-direction: row !important;\n}\n\n.MuiInputLabel-root {\n  margin-top: -9px !important;\n}\n\n.MuiStack-root {\n  display: inline-table !important;\n}\n\n.container-space {\n  padding-left: 30px;\n  margin-top: 0px;\n}\n\n.MuiPaper-root {\n  margin-bottom: 0.25rem !important;\n  border-radius: 4px !important;\n  border: 1px solid rgba(0, 0, 0, 0.12) !important;\n}\n\n/* .MuiPaper-root .MuiAccordionSummary-root {\n  margin-bottom: 10px !important;\n} */\n\n.css-uvvswg-MuiButtonBase-root-MuiAccordionSummary-root {\n  background-color: unset !important;\n}\n\n.css-1fderfv-MuiPaper-root-MuiAccordion-root:not(:last-child) {\n  border-bottom: inset !important;\n}\n\n.css-1fderfv-MuiPaper-root-MuiAccordion-root {\n  border-radius: 6px;\n}\n\n.Mui-expanded .MuiAccordionSummary-root:first-of-type {\n  border-radius: 4px !important;\n  background: #1fb5ad !important;\n  margin-bottom: 10px !important;\n}\n\n.Mui-expanded>.MuiTypography-root {\n  font-weight: 600 !important;\n  font-size: 1rem !important;\n  /*1.25rem !important; */\n  color: #ffffff;\n}\n\n\n.MuiAccordionSummary-root {\n  font-weight: 600 !important;\n  font-size: 1rem !important;\n  /*1.25rem !important; */\n  color: #767676;\n  font-family: sans-serif !important;\n}\n\n.MuiTypography-root {\n  font-weight: 600 !important;\n  font-size: 1rem !important;\n  /*1.25rem !important; */\n  color: #767676;\n  font-family: sans-serif !important;\n}\n\n.Mui-expanded .MuiAccordionSummary-expandIconWrapper {\n  color: #ffffff !important;\n}\n\n.MuiAccordionDetails-root {\n  padding: 1px 16px 16px !important;\n}\n\n\n\n.Card-Icon {\n  background: #f3ebfd;\n  padding: 5px;\n  border-radius: 4px;\n  width: 45px !important;\n  height: 45px !important;\n}\n\n.Card {\n  padding: 10px;\n  height: 60px;\n  margin-right: 5px;\n}\n\n.Card-Text {\n  color: #767676 !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n  text-align: center;\n  display: block;\n  top: 30px !important;\n  position: absolute;\n}\n\n.Card-text-Percentage {\n  color: #e857b8 !important;\n  font-size: 9px !important;\n  background: #f3ebfd;\n  width: 80px;\n  text-align: center;\n  border-radius: 2px;\n  letter-spacing: 0.5px;\n  font-weight: bold !important;\n  margin-top: 10px !important;\n}\n\n.LeftText1 {\n  /* position: absolute;\n  right: 26px;\n  top: 77px; */\n  border-left: 1.4px solid #f3f2f2;\n  padding: 2px 4px 8px 32px;\n  min-width: 3rem;\n}\n\n.__LeftText2 {\n  margin: 0;\n  padding: 0;\n  font-size: 22px !important;\n  font-weight: 700 !important;\n  color: #748076 !important;\n}\n\n.__LeftText3 {\n  margin: 0;\n  font-size: 9px !important;\n  text-align: center !important;\n  color: #748076 !important;\n}\n\n._InputBox {\n  width: -webkit-fill-available !important;\n  height: 40px !important;\n  margin-top: 1px;\n}\n\n.__Input-label {\n  font-size: 12px !important;\n  font-weight: 600 !important;\n  padding: 3px 0 0px 3px !important;\n  margin-bottom: 4px;\n}\n\n.__buttonleft {\n  margin-right: 36px !important;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.__butn {\n  background: #1fb5ad !important;\n  font-size: 12px !important;\n  text-transform: capitalize !important;\n  width: 100px !important;\n}\n\n.MuiInputBase-input {\n  font-size: 13px !important;\n}\n\n.css-v84d5j-MuiSvgIcon-root {\n  font-size: 1.3rem !important;\n  text-align: justify;\n}\n\n.MuiFormControl-root {\n  max-width: 100% !important;\n}\n\n\n.MuiFormControl-root:first-child>.MuiFormLabel-root {\n  display: none !important;\n}\n\n.MuiFormControl-root .css-14lo706 {\n  display: none !important;\n}\n\n.MuiFormControl-root:nth-child(2)>.MuiFormLabel-root {\n  left: -2.4rem !important;\n  top: 1.4rem !important;\n  font-size: 19px;\n}\n\n.css-9npbnl-MuiFormLabel-root-MuiInputLabel-root {\n  margin-bottom: 0 !important;\n}\n\n.css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root {\n  margin-top: 0 !important;\n  /* padding: 0px 9px 8px 0 !important; */\n}\n\n.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root {\n  padding: 0px 9px 8px 0 !important;\n}\n\n.switchform {\n  flex-direction: row !important\n}\n\n.infoicon {\n  margin: 10px 0 0 0;\n  color: rgb(34 0 70);\n  border: 2px solid #bdb9b9;\n  border-radius: 50%;\n  background: #ffffff;\n}\n\n.MuiGrid-item {\n  position: relative !important;\n}\n\n.MuiGrid-item:nth-child(1) .MuiFormControl-root {\n  margin-top: 2px !important;\n  width: -webkit-fill-available !important;\n}\n\n\n.MuiGrid-item:nth-child(2) .MuiFormControl-root {\n  margin-top: -2px !important;\n  width: -webkit-fill-available !important;\n}\n\n.Toastify__toast--error {\n  color: #000000 !important;\n  background-color: #ff7f7f !important;\n  /* Set your desired background color */\n}\n\n.Toastify__toast--success {\n  color: #000000 !important;\n  background-color: #7fff7f !important;\n  /* Set your desired background color */\n}\n\n.Toastify__toast--info {\n  color: #000000 !important;\n  background-color: #fdff7f !important;\n  /* Set your desired background color */\n}\n\n@media only screen and (max-width: 500px) {\n  .to-timepicker {\n    margin-top: 10px !important;\n  }\n}\n\n@media only screen and (max-width: 700px) {\n  .to-timepicker {\n    margin-top: 10px !important;\n  }\n}\n\n@media only screen and (max-width: 800px) {\n  .to-timepicker {\n    margin-top: 10px !important;\n  }\n}\n\n.griddd .MuiGrid-root .MuiGrid-item {\n  padding-left: 16px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
